'use client';

import { Box, IconButton, Logo } from 'ui';
import { Close } from 'ui/icons';

interface Props {
  toggleSidebar: () => void;
}

const MobileHeader = ({ toggleSidebar }: Props) => {
  return (
    <Box display="flex" flexDirection="row" mr={2} pt={2} justifyContent="space-between" alignItems="center">
      <IconButton onClick={toggleSidebar} data-testid="close-sidebar-button">
        <Close sx={{ color: 'common.black' }} />
      </IconButton>

      <Logo source="/images/logo.svg" size="small" />
    </Box>
  );
};

export { MobileHeader };
